export default {
  name: 'server-error',
}
